import { render, staticRenderFns } from "./MyIuguAccount.vue?vue&type=template&id=380b6ee0&scoped=true&"
import script from "./MyIuguAccount.vue?vue&type=script&lang=js&"
export * from "./MyIuguAccount.vue?vue&type=script&lang=js&"
import style0 from "./MyIuguAccount.vue?vue&type=style&index=0&id=380b6ee0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380b6ee0",
  null
  
)

export default component.exports